// Analytics events: GA4 / GTM (dataLayer), Snap and TikTok pixels — only when configured.
import { $, $$ } from "./util";

const has = () => window.dataLayer || window.snaptr || window.ttq;
function ev(name, params) {
	if (!has()) return;
	try {
		(window.dataLayer = window.dataLayer || []).push({ ecommerce: null });
		window.dataLayer.push({ event: name, ecommerce: params });
		if (window.snaptr) window.snaptr("track", { view_item: "VIEW_CONTENT", add_to_cart: "ADD_CART", begin_checkout: "START_CHECKOUT", purchase: "PURCHASE" }[name] || "CUSTOM_EVENT_1",
			{ price: params.value, currency: "SAR", item_ids: (params.items || []).map((i) => i.item_id) });
		if (window.ttq) window.ttq.track({ view_item: "ViewContent", add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout", purchase: "CompletePayment" }[name] || name,
			{ value: params.value, currency: "SAR", contents: (params.items || []).map((i) => ({ content_id: i.item_id, quantity: i.quantity || 1 })) });
	} catch (e) { /* never break the page for analytics */ }
}

export function initTracking() {
	if (!has()) return;
	const pdp = $("[data-buy]");
	if (pdp) {
		const price = parseFloat((document.querySelector("script[type='application/ld+json']")?.textContent.match(/"price":\s*([\d.]+)/) || [])[1] || 0);
		ev("view_item", { currency: "SAR", value: price, items: [{ item_id: pdp.dataset.buy, price }] });
	}
	document.addEventListener("click", (e) => {
		const a = e.target.closest("[data-add]:not([disabled])");
		if (a) ev("add_to_cart", { currency: "SAR", items: [{ item_id: a.dataset.add, quantity: 1 }] });
	}, true);
	if ($("[data-checkout-form]")) ev("begin_checkout", { currency: "SAR", items: (JSON.parse(localStorage.getItem("darat_cart") || "[]")).map((l) => ({ item_id: l.c, quantity: l.qty })) });
	if ($("[data-confetti]") && location.search.includes("new=1")) {
		const order = $(".ds-order h1 b, .ds-lead b[dir=ltr]")?.textContent || "";
		const total = parseFloat(($(".ds-row--total b")?.textContent || "").replace(/[^\d.]/g, "")) || 0;
		ev("purchase", { transaction_id: order, currency: "SAR", value: total, items: [] });
	}
}
